import { ChangeRequestStatus, ChangeRequestType, TradeContractChangeRequest } from "@/app/types/generated/graphql";

import { demoTradeContractById } from "../orders/demo-orders";

export const demoTradeContractChangeRequestHistory: TradeContractChangeRequest[] = [
  {
    changeRequestId: "TCCR-102",
    deliveryDate: "2025-09-20",
    paymentDate: "2025-09-20",
    requestedOn: "2025-09-22T02:53:28.653Z",
    respondedOn: null,
    status: ChangeRequestStatus.Open,
    type: ChangeRequestType.Outgoing,
  },
  {
    changeRequestId: "TCCR-101",
    deliveryDate: "2025-09-22",
    paymentDate: "2025-09-22",
    requestedOn: "2025-09-21T02:53:28.653Z",
    respondedOn: "2025-09-22T02:53:28.653Z",
    status: ChangeRequestStatus.Rejected,
    type: ChangeRequestType.Incoming,
  },
];

export const tradeContractChangeRequestHistoryQuery = {
  read(...vars: any) {
    const id = vars[0].input.tradeContractId;

    if (id !== demoTradeContractById.id) return [];

    return [
      {
        changeRequestId: "3798e3fe-3dd8-4fd9-a4ab-8a61504efb57",
        deliveryDate: "2028-12-31",
        paymentDate: "2028-11-28",
        requestedOn: "2025-11-13T08:14:55.927Z",
        respondedOn: null,
        status: "OPEN",
        type: "OUTGOING",
        __typename: "TradeContractChangeRequest",
      },
    ];
  },
};
